<ax-value-view-label [label]="label">
  <span class="ql-editor" [innerHTML]="safeHtml"></span>
</ax-value-view-label>
